// components/ProtectedRoute.js
import { Navigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { CircularProgress, Box } from "@mui/material";
import { useAppAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, isLoading } = useAuth0();
  const { appUser, loading: appUserLoading } = useAppAuth();

  // Wait for both Auth0 and appUser to finish loading
  if (isLoading || appUserLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // Not logged in
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const role = appUser?.role?.toLowerCase() || "seller";
  const allowed = (allowedRoles || []).map((r) => r.toLowerCase());

  // If super_admin, allow access if allowedRoles includes either admin or super_admin
  const isAllowed =
    role === "super_admin"
      ? allowed.includes("super_admin") || allowed.includes("admin")
      : allowed.includes(role);



  if (allowedRoles && !isAllowed) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;
